import React from "react";
import { createPortal } from "react-dom";
import "./styles.css";

type AlertModalProps = {
  visible: boolean;
  title?: string;
  message: string;
  confirmText?: string;
  onConfirm: () => void;
};

const AlertModal: React.FC<AlertModalProps> = ({
  visible,
  title = "Alert",
  message,
  confirmText = "OKAY",
  onConfirm,
}) => {
  if (!visible) {
    return null;
  }

  const modalRoot = document.getElementById("modal-root") || document.body;

  return createPortal(
    <div className="ModalOverlay alert-modal-overlay" onClick={onConfirm}>
      <div
        className="alert-modal-card"
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        <h2 className="alert-modal-title">{title}</h2>
        <p className="alert-modal-message">{message}</p>
        <button type="button" className="alert-modal-button" onClick={onConfirm}>
          {confirmText}
        </button>
      </div>
    </div>,
    modalRoot
  );
};

export default AlertModal;